/**
 * Formats a contact name for the inbox message list row (MessageCard).
 * Trims whitespace only — actual truncation for display is left entirely to
 * CSS (`white-space:nowrap` + `overflow:hidden` + `text-overflow:ellipsis`
 * on the name Typography in MessageCard.jsx), so how much of the name shows
 * tracks the row's real, responsive available width instead of a guess.
 *
 * This used to hard-cut at a fixed 12 characters in plain JS (2026-08-22),
 * added because CSS-only ellipsis wasn't reliably showing "…" at the time —
 * a `display:flex` bug on the name's own container broke `text-overflow`
 * entirely (ellipsis has no effect inside a flex formatting context per
 * spec), so long names got silently cropped with no visual sign anything
 * was cut, only discoverable via the tooltip. That flex bug is fixed now
 * (the name Typography renders as a plain block), so CSS ellipsis is
 * reliable again — and unlike the fixed 12-char cut, it naturally adapts to
 * however wide the row actually is (2026-09-09, Rahim: name truncated with
 * lots of free space and stayed truncated even after the panel was made
 * much wider, because the JS cut never looked at pixel width at all).
 *
 * MessageCard.jsx pairs this with a real overflow check (scrollWidth vs
 * clientWidth on the rendered name) to show the full-name tooltip only when
 * the name is genuinely visually truncated, not based on this function's
 * output.
 *
 * @param {unknown} name
 * @returns {string}
 */
export function formatMessageCardContactDisplayName(name) {
  if (name == null) return "";
  return String(name).trim();
}
